import { Grid } from '@mui/material'
import { KoreanSchoolContentForm } from '../Organisms'

export default () => {
  return (
    <Grid container rowSpacing={4}>
      <Grid item xs={12}>
        <KoreanSchoolContentForm />
      </Grid>
    </Grid>
  )
}
